import React, { createContext, useReducer } from "react";
import {NotificationType} from "../screens/icip_admin_screen/components/GenericWrapper";

interface NotificationContextState {
  type: NotificationType;
  message: string | null;
}

interface NotificationContextAction {
  data: {
    type?: NotificationType;
    message?: any;
  }
}

export const NotificationContext = createContext<NotificationContextState>(initState());
NotificationContext.displayName = "Notification wrapper context";
export const NotificationDispatchContext = createContext<Function>(() => {});
NotificationDispatchContext.displayName = "Notification wrapper dispatch context";

function NotificationReducer(state: NotificationContextState, action: NotificationContextAction): NotificationContextState {
  return {
    ...state,
    ...action.data,
  };
}

export const NotificationProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(NotificationReducer, initState());

  return (
    <NotificationContext.Provider value={state}>
      <NotificationDispatchContext.Provider value={dispatch}>
        {children}
      </NotificationDispatchContext.Provider>
    </NotificationContext.Provider>
  );
};

function initState(): NotificationContextState {
  return {
    type: "error",
    message: null,
  };
}